import MultiFileLoader from './MultiFileLoader';

angular.module('sfx.file', []).service('multiFileLoader', MultiFileLoader);
